import * as Yup from 'yup'

import flow from 'lodash/fp/flow'

import email from '@galo-monitor/forms/validators/email.validator'
import equal from '@galo-monitor/forms/validators/equal.validator'
import phone from '@galo-monitor/forms/validators/phone.validator'
import required from '@galo-monitor/forms/validators/required.validator'

const companySchema = ({ t, data }) => Yup.object().shape({
  name_company: required({ t })(Yup.string()),
  name_responsible: required({ t })(Yup.string()),
  phone_responsible: flow(
    phone({ t }),
    required({ t })
  )(Yup.string()),
  email_responsible: flow(
    email({ t }),
    required({ t })
  )(Yup.string()),
  repeat_email_responsible: flow(
    equal({ t, text: 'emails do not match', compareWith: data.email_responsible }),
    required({ t })
  )(Yup.string()),
  modules_companies: Yup.array().of(
    Yup.object().shape({ id: Yup.string() })
  ).nullable(),
  modules_farms: Yup.array().of(
    Yup.object().shape({ id: Yup.string() })
  ).nullable()
})

export default companySchema
